import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <main className='notfound-shell'>
      <p className='eyebrow'>404</p>
      <h1 className='display'>Off the map.</h1>
      <p className='lede'>
        That route doesn't exist. <Link to='/'>Return to the index.</Link>
      </p>
    </main>
  )
}
